import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Scatter, Chart } from "react-chartjs-2";
import { localize } from "linksoft";
import { loadData } from "./actions";
import ChartBase from "../chartsBase/chart-base";
import moduleName from "./module";
import FullscreenWrapper from "../chart-fullscreen-wrapper/chart-fullscreen-wrapper";
import "chartjs-plugin-annotation";

const Resx = localize("App");

function mapStateToProps(state) {
  return {
    coordinates: state[moduleName].coordinates,
    processing: state[moduleName].processing,
    currentMin: state[moduleName].currentMin,
    currentMax: state[moduleName].currentMax,
  };
}

const mapDispatchToProps = {
  loadData: loadData,
};

@connect(mapStateToProps, mapDispatchToProps)
class ChainageChart extends ChartBase {
  static propTypes = {
    height: PropTypes.number,
    excavationIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    coordinates: PropTypes.arrayOf(PropTypes.object),
    processing: PropTypes.bool,
    profileId: PropTypes.number,
    hideHeader: PropTypes.bool,
    currentMin: PropTypes.instanceOf(Date),
    currentMax: PropTypes.instanceOf(Date),
    registerRangeReference: PropTypes.func,
    onPlotVisibilityChanged: PropTypes.func,
    registerChartReference: PropTypes.func,
    annotation: PropTypes.object,
    dataXAxisMin: PropTypes.string,
    dataXAxisMax: PropTypes.string,
    xScaleUnit: PropTypes.string,
    };

    componentDidMount() {
    const {
      loadData,
      excavationIds,
      profileId,
      registerRangeReference,
      registerChartReference,
    } = this.props;
        loadData(excavationIds, profileId);
    this.setState({
      currentMin: 0,
      currentMax: 0,
    });
    
    if (registerRangeReference) {
        registerRangeReference(this);
    }

    if (registerChartReference) {
        registerChartReference(this);
        }
  }

  render() {
      const { processing, height } = this.props;
    return (
      <div>
        {processing ? (
          this.progressLoader()
        ) : (
          <FullscreenWrapper>
            <Scatter
              ref="chart"
                            data={this.getDataForXYChart()}
                            options={this.xyOptions()}
              height={height}
            />
          </FullscreenWrapper>
        )}
      </div>
    );
  }

  xyOptions() {
    const {
      annotation,
      coordinates,
      profileId,
      hideHeader,
      onPlotVisibilityChanged,
      dataXAxisMin,
      dataXAxisMax,
      xScaleUnit,
    } = this.props;
    const points = coordinates.reduce(
      (acc, curr) => acc.concat(curr.chainages),
      []
    );
    const offset = 0;
    const profileChainageYRange = 20;
    const isProfileChainage = !!profileId;
    const showHeader = hideHeader !== true;

    let xAxisMax = 0;
    let xAxisMin = 0;
    let yAxisMin = 0;
    let yAxisMax = 0;
    let unit = coordinates.length > 0 ? coordinates[0].unit : "day";

    if (points.length) {
      const dates = points.map((item) => item.x);
      let max = dates.reduce((a, b) => {
        return a > b ? a : b;
      });
      let min = dates.reduce((a, b) => {
        return a < b ? a : b;
      });

      if (unit === "automatic") {
        unit = null;
      }
      if (!isNullOrUndefined(dataXAxisMax)) {
        max = dataXAxisMax;
      }
      if (!isNullOrUndefined(dataXAxisMin)) {
        min = dataXAxisMin;
      }
      
      // restore scaling from URL param
      const searchParams = new URLSearchParams(location.search);
      if (searchParams.has("excavationScaling")) {
        const excavationScaling = JSON.parse(
          searchParams.get("excavationScaling")
        );
        if (
          excavationScaling &&
          excavationScaling.start !== "" &&
          excavationScaling.end !== ""
        ) {
          min = excavationScaling.start;
          max = excavationScaling.end;
        }
      }

      const mx = new Date(max);
      const mn = new Date(min);
      let maxOffset = 0;
      let minOffset = 0;
      if (!isNullOrUndefined(this.state)) {
        if (this.state.currentMax !== 0) {
            maxOffset = dayDiff(max, this.state.currentMax);
          if (maxOffset > 0) {
            //maxOffset = 0
          }
        }

        if (this.state.currentMin !== 0) {
            minOffset = dayDiff(min, this.state.currentMin);

          if (minOffset < 0) {
            //minOffset = 0
          }
        }
      }
      
      var dateValMax = new Date(max);
      var dateValMin = new Date(min);
      mx.setDate(dateValMax.getDate() + offset + maxOffset);
      mn.setDate(dateValMin.getDate() - offset + minOffset);
      xAxisMax = moment(mx).startOf("day").valueOf();
      xAxisMin = moment(mn).startOf("day").valueOf();
      yAxisMax = isProfileChainage
        ? profileChainageYRange
        : Math.max.apply(
            null,
            points.map((item) => item.y)
          ) + offset;
      yAxisMin = isProfileChainage
        ? -profileChainageYRange
        : Math.min.apply(
            null,
            points.map((item) => item.y)
          ) - offset;
    }

    return {
      annotation: annotation,
      legend: {
        display: showHeader && coordinates.length > 1,
        onClick: isNullOrUndefined(onPlotVisibilityChanged)
          ? function (event, item) {
              Chart.defaults.global.legend.onClick.call(this, event, item);
            }
          : onPlotVisibilityChanged,
      },
      tooltips: {
          enabled: true,
      },
      title: {
        display: showHeader,
        text: Resx.App.Excavations,
      },
      layout: {
        layoutPaddingDto: {},
      },
      scalingControls: {
        xAxisScalingControl: {
          display: true,
          label: Resx.App.MeasurementDate,
          scalingProperty: "time",
          stepSize: 86400000,
          useAlwaysDataMax: true
        },
        yAxisScalingControl: {
          display: true,
          label: "tm",
          scalingProperty: "ticks",
          stepSize: 1
        }
      },
      scales: {
        xAxes: [
          {
            display: true,
            afterFit: (axis) => {
                axis.paddingRight = 50
            },
            scaleLabel: {
                display: true,
                labelString: Resx.App.MeasurementDate
            },
            type: "time",
            time: {
              unit: unit,
              min: xAxisMin,
              max: xAxisMax,
              stepSize: 1,
              displayFormats: {
                day: "DD.MM.YY",
                week: "DD.MM.YY",
                month: "MM/YY",
                hour: "DD.MM.YY HH:mm"
              },
              autoSkip: true,
              isoWeekday: true,
              maxRotation: 90,
              minUnit: "day",
              padding: 10,
              tooltipFormat: "DD.MM.YYYY",
              min: xAxisMin,
              max: xAxisMax,
              ...(unit != "hour" && { unit: unit }),
              ...(unit != null && { stepSize: 1 })
            },
            position: "bottom",
            gridLines: {
              color: "rgba(137, 139, 186, .3)",
              drawOnChartArea: true,
            },
          },
        ],
        yAxes: [
          {
            display: true,
            afterFit: (axis) => {
              axis.width = 90
            },
            scaleLabel: {
              labelString: `${Resx.App.ExcavationsProgress} [tm]`,
              display: true,
            },
            type: "linear",
            position: "bottom",
            gridLines: {
              color: "rgba(137, 139, 186, .3)",
              drawOnChartArea: true,
            },
            ticks: {
              min: yAxisMin,
              max: yAxisMax,
              padding: 10
            }
          },
        ],
      },
    };
  }

  getOrderedPoints(coordinates) {
    var orderedPoints = (coordinates || []).slice();
    orderedPoints.sort(this.compareChainage);

    return orderedPoints;
  }

  getDataForXYChart() {
    const datasets = this.props.coordinates.map((c) => ({
      label: c.excavationName,
      data: this.getOrderedPoints(c.chainages),
      backgroundColor: `rgba(${c.gisLayerColor}, .7)`,
      pointBackgroundColor: `rgba(${c.gisLayerColor}, .7)`,
      borderColor: `rgba(${c.gisLayerColor}, 1)`,
      pointBackgroundColor: `rgba(${c.gisLayerColor}, .7)`,
      pointHoverBackgroundColor: `rgba(${c.gisLayerColor}, 1)`,
      pointBorderColor: `rgba(${c.gisLayerColor}, .7)`,
      pointHoverBorderColor: `rgba(${c.gisLayerColor}, 1)`,
      borderWidth: 3,
      pointRadius: 7,
      pointHoverRadius: 10,
      pointBorderWidth: 2,
      fill: false,
      tension: 0,
      showLine: true,
      offset: true,
      padding: 20,
      steppedLine: true,
    }));
    
    return {
      datasets,
    };
  }

  compareChainage(a, b) {
    if (a.x < b.x) {
      return -1;
    }
    if (a.x > b.x) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }

  refName = makeid();
}

const makeid = () => {
  let text = "";
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

const dayDiff = (date1, date2) => {
    let a = moment(date2).startOf("day")
    let b = moment(date1).startOf("day")
    return Math.floor(a.diff(b, 'days',true));
};

const isNullOrUndefined = (val) => {
  return val === null || val === undefined;
};

export default ChainageChart;



// WEBPACK FOOTER //
// ./App/components/modules/chainageChart/chart.js